// // // // src/components/Footer.jsx

// // // import React from 'react';
// // // import { Link } from 'react-router-dom';

// // // const Footer = () => {
// // //   return (
// // //     <footer className="bg-[#141e30] text-white px-6 py-10 mt-16">
// // //       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        
// // //         {/* Contact Section */}
// // //         <div>
// // //           <h2 className="text-xl font-semibold mb-4">Contact Us</h2>
// // //           <p className="mb-2">📧 <a href="mailto:enquiries@isnartech.com" className="hover:underline text-indigo-400">enquiries@isnartech.com</a></p>
// // //           <p className="mb-2">📞 +91-9891940289, +91-7704836280</p>
// // //           <p>🏢 Tower D, Sector-102, Gurgaon, India</p>
// // //         </div>

// // //         {/* Quick Links */}
// // //         <div>
// // //           <h2 className="text-xl font-semibold mb-4">Quick Links</h2>
// // //           <ul className="space-y-2">
// // //             <li>
// // //               <Link to="/" className="hover:text-indigo-400 transition">Home</Link>
// // //             </li>
// // //             <li>
// // //               <Link to="/features" className="hover:text-indigo-400 transition">Features</Link>
// // //             </li>
// // //             <li>
// // //               <Link to="/registerSchool" className="hover:text-indigo-400 transition">Register Your School</Link>
// // //             </li>
// // //           </ul>
// // //         </div>

// // //         {/* Legal Section */}
// // //         <div>
// // //           <h2 className="text-xl font-semibold mb-4">Legal</h2>
// // //           <ul className="space-y-2">
// // //             <li>
// // //               <Link to="/privacy-policy" className="hover:text-indigo-400 transition">Privacy Policy</Link>
// // //             </li>
// // //             <li>
// // //               <Link to="/terms-and-conditions" className="hover:text-indigo-400 transition">Terms & Conditions</Link>
// // //             </li>
// // //           </ul>
// // //         </div>
// // //       </div>

// // //       {/* Bottom Bar */}
// // //       <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-400">
// // //         © {new Date().getFullYear()} Isnartech Pvt. Ltd. All rights reserved.
// // //       </div>
// // //     </footer>
// // //   );
// // // };

// // // export default Footer;


// // import React from 'react';
// // import { Link } from 'react-router-dom';

// // const Footer = () => {
// //   return (
// //     <footer className="bg-white border-t border-[#E3E8F0] px-6 py-14 mt-8">
// //       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
// //         <div>
// //           <h2 className="font-['Sora',sans-serif] text-[#101826] font-semibold mb-4">Contact us</h2>
// //           <p className="mb-2 font-['Sora',sans-serif] text-[#5A6478] text-sm">
// //             <a href="mailto:enquiries@isnartech.com" className="hover:text-[#2E63B8] transition">
// //               enquiries@isnartech.com
// //             </a>
// //           </p>
// //           <p className="mb-2 font-['Sora',sans-serif] text-[#5A6478] text-sm">
// //             +91-9891940289, +91-7704836280
// //           </p>
// //           <p className="font-['Sora',sans-serif] text-[#5A6478] text-sm">
// //             Tower D, Sector-102, Gurgaon, India
// //           </p>
// //         </div>

// //         <div>
// //           <h2 className="font-['Sora',sans-serif] text-[#101826] font-semibold mb-4">Quick links</h2>
// //           <ul className="space-y-2 font-['Sora',sans-serif] text-sm">
// //             <li><Link to="/" className="text-[#5A6478] hover:text-[#2E63B8] transition">Home</Link></li>
// //             <li><Link to="/features" className="text-[#5A6478] hover:text-[#2E63B8] transition">Features</Link></li>
// //             <li><Link to="/registerSchool" className="text-[#5A6478] hover:text-[#2E63B8] transition">Register your school</Link></li>
// //           </ul>
// //         </div>

// //         <div>
// //           <h2 className="font-['Sora',sans-serif] text-[#101826] font-semibold mb-4">Legal</h2>
// //           <ul className="space-y-2 font-['Sora',sans-serif] text-sm">
// //             <li><Link to="/privacy-policy" className="text-[#5A6478] hover:text-[#2E63B8] transition">Privacy policy</Link></li>
// //             <li><Link to="/terms-and-conditions" className="text-[#5A6478] hover:text-[#2E63B8] transition">Terms & conditions</Link></li>
// //           </ul>
// //         </div>
// //       </div>

// //       <div className="max-w-7xl mx-auto border-t border-[#E3E8F0] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
// //         <p className="text-sm text-[#8891A0] font-['Sora',sans-serif]">
// //           © {new Date().getFullYear()} Eduvantra. All rights reserved.
// //         </p>
// //         <a
// //           href="https://www.isnartech.com/"
// //           target="_blank"
// //           rel="noopener noreferrer"
// //           className="text-sm text-[#8891A0] font-['Sora',sans-serif] hover:text-[#2E63B8] transition"
// //         >
// //           A product of Isnartech Pvt. Ltd.
// //         </a>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// // src/components/Footer.jsx
// // Rendered once in App.jsx so it appears on every route, not just the homepage.

// import React from 'react';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   return (
//     <footer className="relative w-full bg-[#101E36] text-[#C9D3E3] mt-8">
//       <div className="h-[3px] w-full bg-gradient-to-r from-[#E8A63C] via-[#2E63B8] to-[#163863]" />

//       <div className="max-w-7xl mx-auto px-6 md:px-16 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
//         <div>
//           <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Contact us</h2>
//           <p className="mb-2 font-['Sora',sans-serif] text-sm">
//             <a href="mailto:enquiries@isnartech.com" className="hover:text-white transition">
//               enquiries@isnartech.com
//             </a>
//           </p>
//           <p className="mb-2 font-['Sora',sans-serif] text-sm">
//             +91-9891940289, +91-7704836280
//           </p>
//           <p className="font-['Sora',sans-serif] text-sm">
//             Tower D, Sector-102, Gurgaon, India
//           </p>
//         </div>

//         <div>
//           <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Quick links</h2>
//           <ul className="space-y-2 font-['Sora',sans-serif] text-sm">
//             <li><Link to="/" className="hover:text-white transition">Home</Link></li>
//             <li><Link to="/#features" className="hover:text-white transition">Features</Link></li>
//             <li><Link to="/registerSchool" className="hover:text-white transition">Register your school</Link></li>
//           </ul>
//         </div>

//         <div>
//           <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Legal</h2>
//           <ul className="space-y-2 font-['Sora',sans-serif] text-sm">
//             <li><Link to="/privacy-policy" className="hover:text-white transition">Privacy policy</Link></li>
//             <li><Link to="/terms-and-conditions" className="hover:text-white transition">Terms & conditions</Link></li>
//           </ul>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-6 md:px-16 border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
//         <p className="text-sm text-[#8493AD] font-['Sora',sans-serif]">
//           © {new Date().getFullYear()} Eduvantra. All rights reserved.
//         </p>
//         <a
//           href="https://www.isnartech.com/"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="text-sm text-[#8493AD] font-['Sora',sans-serif] hover:text-white transition"
//         >
//           A product of Isnartech Pvt. Ltd.
//         </a>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative w-full bg-[#101E36] text-[#C9D3E3] mt-8">
      <div className="h-[3px] w-full bg-gradient-to-r from-[#E8A63C] via-[#2E63B8] to-[#163863]" />

      <div className="max-w-7xl mx-auto px-6 md:px-16 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Contact us</h2>
          <p className="mb-2 font-['Sora',sans-serif] text-sm">
            <a href="mailto:enquiries@isnartech.com" className="hover:text-white transition">
              enquiries@isnartech.com
            </a>
          </p>
          <p className="mb-2 font-['Sora',sans-serif] text-sm">
            +91-9891940289, +91-7704836280
          </p>
          <p className="font-['Sora',sans-serif] text-sm">
            Tower D, Sector-102, Gurgaon, India
          </p>
        </div>

        <div>
          <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Quick links</h2>
          <ul className="space-y-2 font-['Sora',sans-serif] text-sm">
            <li><Link to="/" className="hover:text-white transition">Home</Link></li>
            <li><Link to="/#features" className="hover:text-white transition">Features</Link></li>
            <li><Link to="/registerSchool" className="hover:text-white transition">Register your school</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Legal</h2>
          <ul className="space-y-2 font-['Sora',sans-serif] text-sm">
            <li><Link to="/privacy-policy" className="hover:text-white transition">Privacy policy</Link></li>
            <li><Link to="/terms-and-conditions" className="hover:text-white transition">Terms & conditions</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="font-['Sora',sans-serif] text-white font-semibold mb-4">Get the app</h2>
          <p className="font-['Sora',sans-serif] text-sm mb-4 text-[#8493AD]">
            Manage everything on the go with the Eduvantra app.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.erpschoolisnartech"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-black border border-white/15 rounded-xl px-4 py-2.5 hover:border-white/40 hover:bg-black/70 transition-all shadow-lg shadow-black/20"
          >
            <svg viewBox="0 0 512 512" className="w-7 h-7 shrink-0" xmlns="http://www.w3.org/2000/svg">
              <path fill="#00D2FF" d="M325.3 234.3L104.6 13.6c-5.6-3.2-11.7-4.9-17.8-4.9-13 0-24.5 7.6-30.2 19.6L325.3 256l229-227.9c-5.9-11.9-17.3-19.4-30.2-19.4-6.1 0-12.2 1.7-17.8 4.9L279.6 234.3z" />
              <path fill="#00F076" d="M56.6 28.3C51.1 34.6 48 43 48 52.1v407.8c0 9.1 3.1 17.5 8.6 23.8L286 256 56.6 28.3z" />
              <path fill="#FF3A44" d="M325.3 256L279.6 277.7 56.6 483.7c5.6 3.2 11.7 4.9 17.8 4.9 6.7 0 13.4-2 19.4-5.9l232-134.2L325.3 256z" />
              <path fill="#FFBC00" d="M506.3 224.1L406 166.4 325.3 256l80.7 89.6 100.3-57.7c14.2-9.9 22.7-25.5 22.7-42.3 0-16.8-8.5-32.4-22.7-41.5z" />
            </svg>
            <span className="flex flex-col leading-tight text-left">
              <span className="text-[10px] text-[#C9D3E3] font-['Sora',sans-serif] tracking-wide">GET IT ON</span>
              <span className="text-base text-white font-['Sora',sans-serif] font-semibold">Google Play</span>
            </span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-16 border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-[#8493AD] font-['Sora',sans-serif]">
          © {new Date().getFullYear()} Eduvantra. All rights reserved.
        </p>
        <a
          href="https://www.isnartech.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-[#8493AD] font-['Sora',sans-serif] hover:text-white transition"
        >
          A product of Isnartech Pvt. Ltd.
        </a>
      </div>
    </footer>
  );
};

export default Footer;